<template>
	<div id="app">
		<div class="mt-4 mb-4">
			<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><a href="/">{{ $t('home') }}</a></li>
				<li class="breadcrumb-item"><a href="/council">{{ $t('city-council') }}</a></li>
				<li class="breadcrumb-item active" aria-current="page">{{ $t('e-voting-title') }}</li>
			</ol>
			</nav>
		</div>		
		<h1 class="mb-4">{{ $t('e-voting-title') }}</h1>
		<nav role="navigation">
			<ul class="nav nav-tabs" id="myTab" role="tablist">
				<li class="nav-item">
					<router-link to="/" class="nav-link" role="tab" aria-controls="home" exact>{{ $t('meetings') }}</router-link>
				</li>
				<li class="nav-item">
					<router-link to="/members" class="nav-link" role="tab" aria-controls="Map">{{ $t('members') }}</router-link>
				</li>
				<li class="nav-item">
					<router-link to="/meeting" class="nav-link" role="tab" aria-controls="Map">{{ $t('meeting') }}</router-link>
				</li>
			</ul>
		</nav>
		<router-view/>
	</div>
</template>

<script>
export default {
}
</script>
<style>

	.container {
		max-width: 100% !important;
	}
	.global-header .container a.logo {
		left: 12px;
	}

</style>